var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17676 8.75H1.92676C1.5816 8.75 1.30176 8.47046 1.30176 8.125V1.875C1.30176 1.52954 1.5816 1.25 1.92676 1.25H8.17676C8.52191 1.25 8.80176 1.52954 8.80176 1.875V8.125C8.80176 8.47046 8.52191 8.75 8.17676 8.75ZM2.55176 7.5H7.55176V2.5H2.55176V7.5Z",
    fill: "#0074B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1768 8.75H11.9268C11.5816 8.75 11.3018 8.47046 11.3018 8.125V1.875C11.3018 1.52954 11.5816 1.25 11.9268 1.25H18.1768C18.5219 1.25 18.8018 1.52954 18.8018 1.875V8.125C18.8018 8.47046 18.5219 8.75 18.1768 8.75ZM12.5518 7.5H17.5518V2.5H12.5518V7.5Z",
    fill: "#0074B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17676 18.75H1.92676C1.5816 18.75 1.30176 18.4705 1.30176 18.125V11.875C1.30176 11.5295 1.5816 11.25 1.92676 11.25H8.17676C8.52191 11.25 8.80176 11.5295 8.80176 11.875V18.125C8.80176 18.4705 8.52191 18.75 8.17676 18.75ZM2.55176 17.5H7.55176V12.5H2.55176V17.5Z",
    fill: "#0074B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8808 16.7963C13.7151 16.7963 13.5561 16.7303 13.4389 16.6132L11.4849 14.6588C11.2407 14.4147 11.2407 14.0192 11.4849 13.775C11.729 13.5309 12.1245 13.5309 12.3687 13.775L13.8808 15.2875L17.7349 11.4331C17.979 11.189 18.3745 11.189 18.6187 11.4331C18.8628 11.6772 18.8628 12.0728 18.6187 12.3169L14.3227 16.6132C14.2055 16.7303 14.0465 16.7963 13.8808 16.7963Z",
    fill: "#0074B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.94d8f02bd57d5a8d83cda3c08ee1ba0d.svg";
export { ForwardRef as ReactComponent };